// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import JQuery from 'jquery';
window.$ = window.jQuery = JQuery;


require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

require('bootstrap')

import CodeScanner from '../libs/code-scanner.min.js';
CodeScanner.bootstrap_version = 5
window.CodeScanner = CodeScanner


$(function(){
  $(document).on("click", ".qrcode-scanner-btn", function(){
    var outputEl = $(this).closest(".input-group").find("input[name='qrcode'], .qrcode-input")
    if(outputEl.length !== 1) throw "Error expect input tag not found"
    CodeScanner.run(outputEl, {title: "QR Code", decoders: ['qrcode'] })
  })

  // Javascript to enable link to tab
  var hash = location.hash
  if (hash) {
    $(`.nav-tabs [data-bs-target="${hash}"]`).tab('show');
  } 
})

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

